import {
  applyPlanModifications,
  cancelPrescriptionAndPa,
  fetchState,
  getPriorAuthDetails,
} from '@lotushealth/lotushealth_js_sdk/endpoints';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function createPrescriptionCancellationApi() {
  const config = await createLotusRequestConfig();
  return {
    archiveProposal: async (patientUserId: string, externalId: string) =>
      (
        await applyPlanModifications(
          patientUserId,
          { modifications: [{ type: 'remove', external_id: externalId }] },
          config
        )
      ).data.result,
    cancel: async (recordId: string) => (await cancelPrescriptionAndPa(recordId, config)).data,
    fetchState: async (patientUserId: string) =>
      (await fetchState(patientUserId, config)).data.state,
    getPriorAuthPrescriptionRecordId: async (priorAuthRecordId: string) =>
      (await getPriorAuthDetails(priorAuthRecordId, config)).data.prescriptionRecordId,
  };
}
